import script from "./waOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./waOrders.vue?vue&type=script&setup=true&lang=js"

import "./waOrders.vue?vue&type=style&index=0&id=0a2b05a4&lang=css"

const __exports__ = script;

export default __exports__